// import React, { useState } from "react";
// import "../../Styles/StudentForm.css";
// import UniversityPage from "./UniversityPage";
// import StudentAutonomousForm from "./StudentAutonomousForm";

// function StudentForm({ memberId, membershipId, personalData, onBackToPersonal }) {

//   const [universityType, setUniversityType] = useState("");
//   const [submitted, setSubmitted] = useState(false);

//   /* -------------------- SUBMIT TYPE -------------------- */
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!universityType) {
//       alert("Please select University or Autonomous");
//       return;
//     }

//     setSubmitted(true);
//   };

//   /* -------------------- BACK FROM CHILD -------------------- */
//   const handleBackFromChild = () => {
//     setSubmitted(false);
//     setUniversityType("");
//   };

//   /* -------------------- UNIVERSITY FLOW -------------------- */
//   if (submitted && universityType === "University") {
//     return (
//       <UniversityPage
//         memberId={memberId}
//         membershipId={membershipId}   // ✅ FIXED
//         personalData={personalData}
//         onBackToPersonal={handleBackFromChild}
//       />
//     );
//   }

//   /* -------------------- AUTONOMOUS FLOW -------------------- */
//   if (submitted && universityType === "Autonomous") {
//     return (
//       <StudentAutonomousForm
//         memberId={memberId}
//         membershipId={membershipId}   // ✅ FIXED
//         personalData={personalData}
//         onBackToPersonal={handleBackFromChild}
//       />
//     );
//   }

//   /* -------------------- SELECT SCREEN -------------------- */
//   return (
//     <div className="student-wrapper">
//       <h3 className="student-title1">STUDENT UN/AU DETAILS</h3>

//       <div className="student-card">
//         <form className="student-form-person" onSubmit={handleSubmit}>

//           <label className="student-label">
//             University or Autonomous <span className="text-danger">*</span>
//           </label>

//           <select
//             className="student-select"
//             value={universityType}
//             onChange={(e) => setUniversityType(e.target.value)}
//           >
//             <option value="">Select One</option>
//             <option value="University">University</option>
//             <option value="Autonomous">Autonomous</option>
//           </select>

//           <div className="student-buttons">
//             <button
//               type="button"
//               className="back-btn"
//               onClick={onBackToPersonal}
//             >
//               ← Back
//             </button>

//             <button type="submit" className="student-btn">
//               Continue
//             </button>
//           </div>

//         </form>
//       </div>
//     </div>
//   );
// }

// export default StudentForm;




import React, { useState } from "react";
import "../../Styles/StudentForm.css";
import UniversityPage from "./UniversityPage";
import StudentAutonomousForm from "./StudentAutonomousForm";

function StudentForm({ memberId, membershipId, personalData, onBackToPersonal }) {

  const [universityType, setUniversityType] = useState("");
  const [submitted, setSubmitted] = useState(false);

  /* -------------------- SUBMIT TYPE -------------------- */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!universityType || universityType.trim() === "") {
      alert("Please select University or Autonomous");
      return;
    }

    setSubmitted(true);
  };

  /* -------------------- BACK FROM CHILD -------------------- */
  const handleBackFromChild = () => {
    setSubmitted(false);
    setUniversityType("");
  };

  /* -------------------- UNIVERSITY FLOW -------------------- */
  if (submitted && universityType === "University") {
    return (
      <UniversityPage
        memberId={memberId}
        membershipId={membershipId}
        personalData={personalData}
        onBackToPersonal={handleBackFromChild}
      />
    );
  }

  /* -------------------- AUTONOMOUS FLOW -------------------- */
  if (submitted && universityType === "Autonomous") {
    return (
      <StudentAutonomousForm
        memberId={memberId}
        membershipId={membershipId}
        personalData={personalData}
        onBackToPersonal={handleBackFromChild}
      />
    );
  }

  /* -------------------- SELECT SCREEN -------------------- */
  return (
    <div className="student-wrapper">
      <h3 className="student-title1">STUDENT UN/AU DETAILS</h3>

      <div className="student-card">
        <form className="student-form-person" onSubmit={handleSubmit}>

          <label className="student-label">
            University or Autonomous <span className="text-danger">*</span>
          </label>

          <select
            className="student-select"
            value={universityType}
            onChange={(e) => setUniversityType(e.target.value)}
            required
          >
            <option value="">Select One</option>
            <option value="University">University</option>
            <option value="Autonomous">Autonomous</option>
          </select>

          <div className="student-buttons">
            <button
              type="button"
              className="back-btn"
              onClick={onBackToPersonal}
            >
              ← Back
            </button>

            <button type="submit" className="student-btn">
              Continue
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default StudentForm;